import { Injectable } from '@angular/core';
import { GetHistoryTripRequest } from 'emr-ng-shared';

@Injectable()
export abstract class ShowViewLogPopup {
    abstract OpenShowViewLogPopup(getHistoryTripRequest: GetHistoryTripRequest): void;
}